import React, {Component} from 'react';
import Cookie from 'js-cookie';
import {errorMessageStyle} from '../styles';
import ProjectService from './project-service';
import Modal from "../modal";

const partialProjectTextStyle = {
    whiteSpace: 'pre-wrap',
    height: '150px',
    maxHeight: '150px',
    overflowY: 'hidden'
};

const fullProjectTextStyle = {
    whiteSpace: 'pre-wrap',
};

const showDetailPlaceHolderStyle = {
    position: 'absolute',
    top: '156px',
    left: 0,
    width: '100%',
    height: '60px',
    background: 'linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1))'
};

const showDetailButtonStyle = {
    display: 'block',
    width: '110px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '20px',
    background: 'rgba(255,255,255,1)'
};

const requestContractButtonStyle = {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '20px',
    marginBottom: '20px'
};

class ContactModal extends Component {
    constructor(props) {
        super(props);
        this.reset();
        this.service = ProjectService;
    }

    componentWillReceiveProps(newProps) {
        if (!this.props.visible && newProps.visible) {
            this.reset();
        }
    }

    reset = () => {
        this.state = {
            contactMethod: 'phone',
            phoneNumber: '',
            emailAddress: Cookie.get('cbadviser-email') || '',
            otherDetails: '',
            isLoading: false
        }
    };

    contactMethodChanged = e => {
        this.setState({contactMethod: e.currentTarget.value});
    };

    inputChanged = e => this.setState({[e.target.id]: e.target.value});

    submit = () => {
        this.setState({isLoading: true});
        const contactDetails = this.state.phoneNumber || this.state.emailAddress || this.state.otherDetails;
        this.service.requestContact(this.state.contactMethod, contactDetails, this.props.projectTitle)
            .done(() => this.props.onClose())
            .fail(e => console.log('Error submitting contact request', e))
            .always(() => this.setState({isLoading: false}))
    };

    isValid = () => {
        return (this.state.contactMethod === 'phone' && this.state.phoneNumber)
            || (this.state.contactMethod === 'email' && this.state.emailAddress)
            || (this.state.contactMethod === 'other' && this.state.otherDetails);
    };

    render() {
        return (
            <Modal visible={this.props.visible} title="Request Contact" onSubmit={this.submit} onClose={this.props.onClose} isValid={this.isValid} isLoading={() => this.state.isLoading}>
                <p>Request contact regarding: {this.props.projectTitle}</p>
                <div>
                    <div className="spaced">
                        <input type="radio" name="contactMethod" value="phone" checked={this.state.contactMethod === 'phone'} onChange={this.contactMethodChanged}/> Phone
                        {this.state.contactMethod === 'phone' ? <input type="text" className="form-control" id="phoneNumber" placeholder="Phone number" value={this.state.phoneNumber} onChange={this.inputChanged} style={{marginTop: '5px'}}/> : undefined }
                    </div>
                    <div className="spaced">
                        <input type="radio" name="contactMethod" value="email" checked={this.state.contactMethod === 'email'} onChange={this.contactMethodChanged}/> Email
                        {this.state.contactMethod === 'email' ? <input type="text" className="form-control" id="emailAddress" placeholder="Email address" value={this.state.emailAddress} onChange={this.inputChanged} style={{marginTop: '5px'}}/> : undefined }
                    </div>
                    <div className="spaced">
                        <input type="radio" name="contactMethod" value="other" checked={this.state.contactMethod === 'other'} onChange={this.contactMethodChanged}/> Other
                        {this.state.contactMethod === 'other' ? <input type="text" className="form-control" id="otherDetails" placeholder="Please specify" value={this.state.otherDetails} onChange={this.inputChanged} style={{marginTop: '5px'}}/> : undefined }
                    </div>
                </div>
            </Modal>
        )
    }
}

class Project extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDetail: false,
            showContactModal: false
        };
    }

    toggleDetail = () => {
        this.setState({showDetail: !this.state.showDetail});
    };

    render() {
        const projectPicture =
            this.props.project.pictureId ?
                (<img src={'/rest/images/' + this.props.project.pictureId} className="project-picture"/>) :
                (<div className="project-picture">
                    <span className="glyphicon glyphicon-picture project-picture-placeholder"/>
                </div>);

        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="panel panel-default" style={{marginTop: '0', marginBottom: '20px'}}>
                        <div className="panel-body">
                            <div className="row">
                                <div className="col-md-2">
                                    {projectPicture}
                                    <button className="btn btn-primary" style={requestContractButtonStyle}
                                            onClick={() => this.setState({showContactModal: true})}>Request Contact</button>
                                </div>
                                <div className="col-md-10">
                                    <div className="cb-header">{this.props.project.title}</div>
                                    <hr/>
                                    <p style={{fontStyle: 'italic'}}>{this.props.project.location}</p>
                                    <p style={this.state.showDetail ? fullProjectTextStyle : partialProjectTextStyle}>
                                        {this.props.project.description}
                                        <div style={this.state.showDetail ? {display: 'none'} : showDetailPlaceHolderStyle}>
                                            <button className="btn btn-default" style={showDetailButtonStyle} onClick={this.toggleDetail}>Show Details</button>
                                        </div>
                                    </p>
                                    <h5>Target Capital: {this.props.project.formattedTargetCapital}</h5>
                                    <h5>Yield: {this.props.project.formattedYield}</h5>
                                    <h5>Tenor: {this.props.project.formattedTenor}</h5>
                                    <h5>Closes On: {this.props.project.formattedClosesOn}</h5>
                                    <div className="other-details">{this.props.project.formattedOtherDetails}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ContactModal visible={this.state.showContactModal}
                              projectTitle={this.props.project.title}
                              onClose={() => this.setState({showContactModal: false})}/>
            </div>)
    }
}

export default class ProjectList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            projects: [],
            isLoading: true,
            errorMessage: ''
        };
        this.service = ProjectService;
    }

    componentDidMount() {
        this.service.projects()
            .done(projects => this.setState({projects: projects}))
            .fail(e => this.setState({errorMessage: e.responseText}))
            .always(() => this.setState({isLoading: false}));
    }

    render() {
        const loading = (
            <div className="big-spinner">
                <span className="spinner big-spinner"></span>
            </div>);

        const noProjects = (
            <div className="lead" style={{textAlign: 'center'}}>
                <p>There are no live projects available on the CB Advisers platform at present.</p>
            </div>);

        const projects = this.state.projects.map(project => <Project project={project}/>);

        return (
            <div>
                <h4>Project List</h4>
                {this.state.errorMessage ?
                    <div className="alert alert-danger" style={errorMessageStyle}>{this.state.errorMessage}</div>
                    : undefined}
                {this.state.isLoading ? loading : this.state.projects.length === 0 ? noProjects : projects }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/members/project-list.js